<template>
  <div class="baseCard">
    <tabLan
      :tabList="tabList"
      @setIndex="tabMenu"
    ></tabLan>
    <div class="partMain">
      <div class="partnerContent">
        <a
          class="partnerItem"
          :href="item.link"
          target="_blank"
          v-for="(item,index) in dataList"
          :key="index"
        >
          <!-- <div class="partnerItemLine"></div> -->
          <img
            :src="item.smallImage"
            alt=""
          >
          <p>{{item.title}}</p>
        </a>
      </div>
      <a-pagination
        class="pages"
		v-model:page="page"
        :total="total"
		:page-size.sync="size"
        @change="changePage"
        show-less-items
      />
    </div>
  </div>
</template>

<script>
import tabLan from "@components/tabLan";
import apiUrls from "@api";
export default {
  data() {
    return {
      tabList: [
        {
          text: "红会系统",
        },
        {
          text: "基金会",
        },
        {
          text: "企业",
        },
        {
          text: "社会组织/商协会",
        },
        {
          text: "个人",
        },
      ],
      page: 1,
      size: 15,
      total: 0,
      dataList: [],
      node: "hzhb_hhxt",
    };
  },

  components: {
    tabLan,
  },

  mounted() {
    this.getSystemList();
  },

  methods: {
    goOtherLink() {},
    tabMenu(index) {
      this.page = 1;
      if (index == 0) {
        this.node = "hzhb_hhxt";
      } else if (index == 1) {
        this.node = "hzhb_jjh";
      } else if (index == 2) {
        this.node = "hzhb_qy";
      } else if (index == 3) {
        this.node = "hzhb_shzzsxh";
      } else if (index == 4) {
        this.node = "hzhb_gr";
      }
      this.getSystemList();
    },
    changePage(page) {
		console.log(page)
      this.page = page;
      this.getSystemList();
    },
    getSystemList() {
      apiUrls
        .getList({
          node: this.node,
          page: this.page - 1,
          size: this.size,
        })
        .then((res) => {
          this.dataList = res.results.data;
          this.total = res.results.pager.totalElements;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.partMain {
  width: 100%;
  height: auto;
  margin-top: 20px;
  border: 1px solid #d8d8d8;

  .pages {
    text-align: right;
    margin: 20px;
  }
}
.partnerContent {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;

  .partnerItem {
    display: inline-block;
    width: 19%;
    height: 180px;
    margin: 5px;
	padding: 5px 0;
    display: flex;
    flex-direction: column;
	justify-content: space-between;
    align-items: center;
    border: 1px solid #d8d8d8;
    color: #000;
    .partnerItemLine {
      height: 5px;
      width: 100%;
      background: #c11818;
    }
    img {
      width: auto;
      height: 150px;
      // margin-top: 10px;
    }
    p {
      text-align: center;
      padding: 0 5px;
    }
  }
}
</style>